import { createContext } from 'react';

import { GtmPayload } from '@gn-audio/jss-core/common/models';

export interface ITrackingContext {
  gtmEvent: (data: GtmPayload, callback?: () => void) => void;
}

const TrackingContext = createContext<ITrackingContext>({
  gtmEvent: () => null,
});

export { TrackingContext };
